<template>
  <div :class="[{flowHide:phoneInputModal},'charge-container']">
    <div class="css-bg">
      <div class="bg"></div>
    </div>
    <div class="customer-phone-area" v-if="userMobile&&userMobile.mobile&&userMobile.mobile==inputPhone">默认号码{{userMobile&&userMobile.company?'（'+companyList[userMobile.company]+'）':''}}</div>
    <div class="customer-phone-area" v-else>{{inputPhoneType?companyList[inputPhoneType]:''}}</div>
    <div class="customer-input">
      <!-- <input placeholder="请输入手机号码"/> -->
      <div :class="inputPhone?'fake-input active':'fake-input'" @click="phoneInputModal=true;getHisPhone();">{{inputPhone?inputPhone:'请输入手机号码'}}</div>
    </div>
    <div class="phone-input-modal" v-show="phoneInputModal">
      <div class="bg" @click="phoneInputModal=false"></div>
      <div class="true-phone-input">
        <div class="input"><input type="number" maxlength="13" placeholder="请输入手机号码" autofocus="autofocus" v-model="inputPhoneTmp" @input="changePhone"/></div>
        <!-- <div class="locked-phone" @click="chosedMobile(userMobile)"><span class="s1">{{userMobile&&userMobile.mobile}}</span><span class="s2">账户绑定手机号</span></div>
        <div class="phone-history" v-show="historyPhone&&historyPhone.length>0">
          <div v-for="(item,i) in historyPhone" :key="i"><span class="s1" @click="chosedMobile(item)">{{item.mobile}}</span></div>
        </div> -->
      </div>
    </div>
    <div class="charge-wrapper">
      <div class="fee-tab">
        <span :class="activeTab===1?'tell active':'tell'" @click="changeTab(1);">
          充话费
          <i></i>
        </span>
        <span :class="activeTab===2?'flow active':'flow'" @click="changeTab(2);">
          充流量
          <i></i>
          </span>
      </div>
      <div class="tellfee" v-show="activeTab===1">
        <div v-for="(item,i) in tellFeeList" :key="i" @click="chosedPlan(item.id);" :class="item.chosed?'tellfee-item active':'tellfee-item'">
          <div class="tellfee-item-amount">{{item.packageName}}</div>
          <div class="tellfee-item-saleAmount">售价：{{item.price}}元</div>
        </div>
      </div>
      <div class="flowfee" v-show="activeTab===2">
          <div v-for="(item,i) in flowFeeList" :key="i" @click="chosedPlan(item.id);" :class="item.chosed?'flowfee-item active':'flowfee-item'">
            <div class="flowfee-item-amount">{{item.packageName}}</div>
            <div class="flowfee-item-saleAmount">售价：{{item.price}}元</div>
          </div>
      </div>
      <div class="deduct">
        <div class="deduct-left">使用积分抵扣</div>
        <div class="deduct-right" @click="changeDeductStatus"><img :src="deductStatus?deductOpen:deductClose"/></div>
      </div>
      <div class="deductNum" v-show="(deductStatus&&activeTab===1&&tellFeeActive)||(deductStatus&&activeTab===2&&flowFeeActive)">
        <span v-show="deductObj.curIntegral&&deductObj.curIntegral>0&&deductObj.deductNum&&deductObj.deductNum>0">您当前积分：{{deductObj.curIntegral}}，本次最多可用{{deductObj.deductNum}}积分（1积分=1元）</span>
        <span v-show="deductObj.curIntegral&&deductObj.curIntegral>0&&Number(deductObj.cfgDeductNum)===0&&Number(deductObj.deductNum)===0" style="color:#666;">该套餐无法使用积分！</span>
        <span v-show="deductObj.curIntegral&&deductObj.curIntegral>0&&Number(deductObj.deductNum)===0&&Number(deductObj.cfgDeductNum)>0" style="color:#666;">当前无可用积分,今日{{activeTab===1?'话费':'流量'}}可抵扣积分已达上限</span>
        <span v-show="Number(deductObj.curIntegral)===0" style="color:#666;">当前无可用积分</span>
        <!-- <span v-if="deductObj.curIntegral&&deductObj.curIntegral>0&&deductObj.deductNum&&deductObj.deductNum>0">当前积分：{{deductObj.curIntegral}}，本次最多可用{{deductObj.deductNum}}积分（1积分=1元）</span>
        <span v-else-if="deductObj.curIntegral&&deductObj.curIntegral>0&&deductObj.deductNum&&Number(deductObj.deductNum)===0" style="color:#666;">当前无可用积分,今日{{activeTab===1?'话费':'流量'}}可抵扣积分已达上限</span>
        <span v-else-if="deductObj.curIntegral&&deductObj.curIntegral>0&&deductObj.cfgDeductNum&&Number(deductObj.cfgDeductNum)===0" style="color:#666;">该套餐无法使用积分！</span>
        <span v-else style="color:#666;">当前无可用积分</span> -->
      </div>
      <div class="deductNum" v-show="blackUser">
        <span style="color:#666;">暂无使用积分权限，请联系客服</span>
      </div>
      <!-- <div class="deductNumInput" v-show="deductObj.curIntegral&&deductObj.curIntegral>0&&deductObj.deductNum&&deductObj.deductNum>0&&((deductStatus&&activeTab===1&&tellFeeActive)||(deductStatus&&activeTab===2&&flowFeeActive))">
        <input type="number" v-model="deductNum" @input="changeDeductNum"/>
      </div> -->
      <div class="shouldpay" v-show="(activeTab===1&&tellFeeActive)||(activeTab===2&&flowFeeActive)">实际支付金额：<span>￥{{shouldPay}}元</span></div>
      <div :class="payBtnActive?'payBtn active':'payBtn'" @click="startPay">立即支付</div>
      <div class="payHistory"><span @click="goPayRecords">交费记录</span>  |  <span @click="chatWith">在线客服</span>  |  <span @click="rechargeRuleShow=true">充值说明</span></div>
    </div>
    <div class="ruleModal" v-show="rechargeRuleShow">
      <div class="bg" @click="rechargeRuleShow=false"></div>
      <div class="content">
        <div class="tit">充值交费说明</div>
        <div class="txt">
          1. 本服务由合作商户提供，暂无法提供充
          值发票。<br/><br/>
          2. 支付成功后，一般15分钟内到账，最迟
          不超过24小时。月初月末为充值高峰期，
          可能会有延迟，建议错峰充值。<br/><br/>
          3. 为了避免您不必要的损失，请在充值前
          仔细核对充值手机号。一旦充值成功将无
          法退回或转存其他号码。<br/><br/>
          4. 充值交费可使用积分抵扣。1积分等值于1元人民币。话费充值和流量充值每日可抵扣积分分别为20积分。<br/><br/>
          5. 如遇到充值失败、到账延迟等问题，请
          点击页面下方联系客服或拨打24小时客服
          热线400-9955-788。<br/>
        </div>
        <div class="btn" @click="rechargeRuleShow=false">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import loading from "@/components/commons/loading";
import lodash from "lodash";
//当前实例组件
export default {
  data() {
    return {
       blackUser:false,//是否黑名单
       deductClose:require('@static/images/rechargeCenter/close.png'),
       deductOpen:require('@static/images/rechargeCenter/open.png'),
       deductStatus:false,
       phoneInputModal:false,
       inputPhoneTmp:'',
       inputPhone:null,
       latestMobile:null,
       inputPhoneType:null,
       userMobile:null,
       companyList:{1:'联通',2:'移动',3:'电信'},
       activeTab:1,
       tellFeeActive:false,
       flowFeeActive:false,
       cardNum1:null,
       cardNum2:null,
       deductObj:{},
       deductNum:0,
       shouldPay:0,
       payTotal:0,
       payBtnActive:false,
       tellFeeList:[],
       flowFeeList:[],
       flowFeeListTmp:[],
       historyPhone:[],
       cfgId:null,
       rechargeRuleShow:false,
       errorPhoneNum:false,//手机号码是否正确
    };
  },
  components: {
    "app-loading": loading //加载中
  },
  created() {
    
  },
  methods: {
    //点击快速选择电话
    chosedMobile(item){
      let mobile = item.mobile;
      console.log(mobile);
      this.inputPhoneTmp = mobile;
      this.phoneInputModal=false;
      this.inputPhone = mobile;
      //调接口，查运营商
      this.getOperators(mobile);
    },
    //创建订单
    createOrder(res){
      //充流量时
      let thirdPakId;
      if(res.data){
        thirdPakId = res.data.id;
      }
      //需要判断是否使用了deductNum
      //(deductStatus&&activeTab===1&&tellFeeActive)||(deductStatus&&activeTab===2&&flowFeeActive)
      let params = {
        mobile:this.inputPhone,
        company:this.inputPhoneType||(this.userMobile&&this.userMobile.company),
        thirdPakId:thirdPakId,
        cfgId:this.cfgId,
        deductNum:(this.deductStatus&&this.activeTab===1&&this.tellFeeActive)||(this.deductStatus&&this.activeTab===2&&this.flowFeeActive)?this.deductNum:null
      }
      console.log("params=====",params);
      //创建订单
      this.$http({
        url: "/policy/recharge/api/createOrder",
        data:params
      })
      .then(res => {
        let link =  /bx.wts999.com/g.test(window.location.origin)?"https://bx.wts999.com":"https://bx.wts9999.net";
        if(location.origin.indexOf("https://bx.lazhuyun.cn")>-1){
          link = "https://bx.lazhuyun.cn";
        }
        location.href = link+"/payments/cashier_recharge.html?tradeNo="+res.data.id;
      })
      .catch(err => {});
    },
    //开始充值
    startPay(){
      if(!this.payBtnActive)return;
      let params = {
        "mobile":this.inputPhone,
        "cardNum":this.activeTab===1?this.cardNum1:this.cardNum2,
        "type":this.activeTab
      }
      console.log("params",params);
      //检查当前充值方案是否可用
      this.$http({
        url: "/policy/recharge/api/telCheck",
        data:params
      })
      .then(res => {
        //方案可用，创建订单
        this.createOrder(res);
      })
      .catch(err => {});
    },
    //交费记录和在线客服
    goPayRecords(){
      this.$router.push({
          path:'/rechargeCenter/chargeRecords'
      });
      sessionStorage.setItem('latestMobileNumber',this.inputPhone);
    },
    chatWith(){
      location.href = "https://wtsbx.qiyukf.com/client?k=59ed88a4552beb1d89cb502bb4885dd6&wp=1&robotShuntSwitch=0&gid=484878140&language=zh-cn&templateId=6674361";
      sessionStorage.setItem('latestMobileNumber',this.inputPhone);
    },
    //改变积分抵扣数值
    changeDeductNum(e){
      let tmp = e.target.value.replace(/\D/g,'');
      let deductNum;
      if(Number(tmp)>0){
        deductNum = Number(e.target.value.replace(/\D/g,''));
      }
      else if(Number(tmp)===0&&tmp.length>1){
        deductNum = 0;
      }
      else{
        deductNum = e.target.value.replace(/\D/g,'');
      }
      
      if(deductNum>this.deductObj.deductNum){
        this.deductNum = this.deductObj.deductNum;
        this.$notice.msg("请输入0~"+this.deductObj.deductNum+"之间的整数！");
      }
      else{
        this.deductNum = deductNum;
      }
      this.shouldPay = Number(this.payTotal) - Number(this.deductNum);
    },
    //历史充值手机号
    getHisPhone(){
      let _this = this;
      this.$http({
        url: "/policy/recharge/api/historyMobile",
        data: {}
      })
      .then(res => {
        let tmpArr = [];
        res.data.map((item)=>{
          console.log("item",item);
          if(item.isUserMobile){
            _this.userMobile = item;
            _this.inputPhone = _this.inputPhone?_this.inputPhone:item.mobile;
            _this.inputPhoneTmp = _this.inputPhoneTmp?_this.inputPhoneTmp:item.mobile;
            _this.getOperators(_this.inputPhone);
          }
          else{
            tmpArr.push(item);
          }
        })
        this.historyPhone = tmpArr;
      })
      .catch(err => {});
    },
    //切换tab
    changeTab(type){
      if(this.activeTab===type)return;
      this.deductNum = 0;
      if(type===1){
        this.activeTab=1;
        this.deductStatus=false;
        this.tellFeeActive=false;
        if(this.inputPhone&&this.tellFeeActive&&this.activeTab===1&&!this.errorPhoneNum){
          this.payBtnActive = true;
        }
        else{
          this.payBtnActive = false;
        }
        this.getTaoCan(1);
      }
      if(type===2){
        this.activeTab=2;
        this.deductStatus=false;
        this.flowFeeActive=false;
        if(this.inputPhone&&this.flowFeeActive&&this.activeTab===2&&!this.errorPhoneNum){
          this.payBtnActive = true;
        }
        else{
          this.payBtnActive = false;
        }
        this.getTaoCan(2);
      }
    },
    changePhone(e){
      let phone = e.target.value.replace(/\D/g,'').substr(0, 11);
      this.inputPhoneTmp = phone;
      if(phone.length===11){
        this.phoneInputModal=false;
        this.inputPhone = phone;
        //调接口，查运营商
        this.getOperators(phone);
      }
    },
    //过滤流量套餐
    filterTaoCan(type){
      console.log("type",type);
      if(type){
        let tmpArr = [];
        this.flowFeeListTmp.map((item)=>{
          //联通1，移动2，电信3
          if(Number(item.company)===Number(type)){
            tmpArr.push(item);
          }
        })
        this.flowFeeList = tmpArr;
      }
      else{
        this.getOperators(this.inputPhone);
      }
    },
    //获取手机号运营商
    getOperators(mobile){
      this.$http({
        url: "/policy/recharge/api/operators",
        type: "get",
        data: {
          'mobile':mobile
        }
      })
      .then(res => {
        this.inputPhoneType = res.data;
        if(this.activeTab===2){
          this.filterTaoCan(res.data);
          this.flowFeeActive=false;
        }
        //手机号码，套餐都选择了的情况下，立即支付可以点击
        if(((this.flowFeeActive&&this.activeTab===2)||(this.tellFeeActive&&this.activeTab===1))&&this.inputPhoneType){
          this.payBtnActive = true;
        }
        else{
          this.payBtnActive = false;
        }
      })
      .catch(err => {
        // this.payBtnActive = false;
        // this.errorPhoneNum = true;
      });
    },
    //可选套餐配置
    getTaoCan(type){
      let _that = this;
      this.$http({
        url: "/policy/recharge/api/type/list",
        data: {
          'type':type
        }
      })
      .then(res => {
        if(type===1){
          _that.tellFeeList = res.data;
        }
        if(type===2){
          _that.flowFeeListTmp = res.data;
          console.log('flowFeeListTmp',_that.flowFeeListTmp);
          _that.filterTaoCan(_that.inputPhoneType||(_that.userMobile&&_that.userMobile.company));
        }
      })
      .catch(err => {});
    },
    //选择套餐 当前套餐可用积分
    chosedPlan(id){
      let _this = this;
      this.cfgId = id;
      if(this.activeTab===1){
        this.tellFeeActive=true;
        this.tellFeeList.map((item)=>{
          item.chosed = item.id === id;
          console.log(item);
          _this.payTotal = item.id === id?item.price:_this.payTotal;
          _this.cardNum1 = item.id === id?item.packageValue:_this.cardNum1;
        })
      }
      if(this.activeTab===2){
        this.flowFeeActive=true;
        this.flowFeeList.map((item)=>{
          item.chosed = item.id === id;
          console.log(item);
          _this.payTotal = item.id === id?item.price:_this.payTotal;
          _this.cardNum2 = item.id === id?item.packageValue:_this.cardNum2;
        })
      }
      //手机号码，套餐都选择了的情况下，立即支付可以点击
      if((this.inputPhone&&((this.flowFeeActive&&this.activeTab===2)||(this.tellFeeActive&&this.activeTab===1)))&&this.inputPhoneType&&!this.errorPhoneNum){
        this.payBtnActive = true;
      }
      else{
        this.payBtnActive = false;
      }
      this.$forceUpdate();
      this.$http({
        url: "/policy/recharge/api/integralInfo",
        data: {
          'cfgId':id
        }
      })
      .then(res => {
        //是否黑名单
        this.blackUser = res.data.blackUser;
        if(!res.data.blackUser){
          this.deductStatus = true;
        }
        else{
          this.deductStatus = false;
        }
        //可使用积分不能大于订单金额
        this.payTotal
        res.data.deductNum = Number(res.data.deductNum)>Number(this.payTotal)?Number(this.payTotal):Number(res.data.deductNum);
        this.deductObj = res.data;
        this.deductNum = res.data.deductNum;
        this.calShouldPay();
      })
      .catch(err => {});
    },
    //是否使用积分抵扣
    changeDeductStatus(){
      //(deductStatus&&activeTab===1&&tellFeeActive)||(deductStatus&&activeTab===2&&flowFeeActive)
      if(this.activeTab===1){
        if(this.tellFeeActive){
          if(this.blackUser){
            this.$notice.msg("暂无使用积分权限，请联系客服!");
            return
          }
          else{
            this.deductStatus=!this.deductStatus;
          }
        }
        else{
          this.$notice.msg("请先选择话费套餐!");
        }
      }
      if(this.activeTab===2){
        if(this.flowFeeActive){
          if(this.blackUser){
            this.$notice.msg("暂无使用积分权限，请联系客服!");
            return
          }
          else{
            this.deductStatus=!this.deductStatus;
          }
        }
        else{
          this.$notice.msg("请先选择流量套餐!");
        }
      }
      this.calShouldPay();
    },
    //计算应付金额
    calShouldPay(){
      // console.log('测试');
      this.deductNum = this.deductObj.deductNum;
      if(this.deductStatus){
        this.shouldPay = Number(this.payTotal) - Number(this.deductNum);
      }
      else{
        this.shouldPay = Number(this.payTotal);
      }
    }
  },
  mounted() {
    if (!this.$units.isLogin(this)) return;
    this.latestMobile = sessionStorage.getItem("latestMobileNumber");
    console.log("latestMobile",this.latestMobile);
    if(this.latestMobile){
      sessionStorage.removeItem("latestMobileNumber");
      this.inputPhone = this.latestMobile;
      this.inputPhoneTmp = this.latestMobile;
      this.getOperators(this.latestMobile);
    }
    else{
      this.getHisPhone();
    }
    this.getTaoCan(1);
  },
  watch:{

  }
};
</script>
<style lang="scss" scoped>
.charge-container {
  width: r(750);
  height: 100vh;
  background: #f5f5f5;
  overflow-y:auto;
  -webkit-overflow-scrolling: touch;
  &.flowHide{
    overflow: hidden;
  }
  .css-bg{
    position: absolute;
    width:100%;    
	  height: r(463);
  .bg{
	width:100%;    
	height: r(463);
	position: relative;  
	z-index:0;  
	overflow: hidden;
}
.bg::after{
	content:''; 
	width: 100%; 
	height:r(400); 
	position: absolute; 
	left: 0;
	top:0;
	z-index: -1; 
	border-radius: 0 0 50% 50%;  
	background:#377AFF;
}
  }
  .charge-wrapper{
    background: #fff;
    width:r(690);
    margin:0 auto;
    padding-bottom:r(140);
    border-radius: r(16);
    z-index: 1;
    position: relative;
  }
  .fee-tab{
    height:r(88);
    line-height:r(88);
    font-size:r(30);
    padding-left:r(25);
    &>span{
      height:r(88);
      // float:left;
      // width:50%;
      text-align:center;
      margin-right:r(30);
      color: #6D7278;
      position: relative;
      padding:r(20) r(10);
      // border-bottom:r(1) solid #e8e8e8;
      &>i{
        width:r(50);
        height:r(8);
        border-radius: r(5);
        background: #fff;
        display: inline-block;
        position:absolute;
        bottom:0;
        left:50%;
        transform: translateX(-50%);
      }
    }
    &>span.active{
      // border-bottom:r(2) solid #4481f6;
      color: #000;
      &>i{
        background: #377AFF;
      }
    }
  }
  .customer-phone-area{
      height:r(95);
      line-height:r(42);
      font-size:r(30);
      padding:r(0) r(40);
      padding-top:r(53);
      // color:#a5a5a5;
      color: #fff;
      font-weight: lighter;
      // width:50%;
          z-index: 1;
    position: relative;
    }
  .customer-input{
    height:r(113);
    line-height:r(83);
    // border-bottom:1px solid #e3e3e3;
    padding:r(0) r(40);
    overflow: hidden;
    z-index: 1;
    position: relative;
    padding-bottom:r(30);
    &>.fake-input{
      height:r(83);
      line-height:r(83);
      font-size:r(37);
      color:#717171;
      width:100%;
      float:left;
      border-bottom:1px solid rgba(255,255,255,0.1);
    }
    &>.fake-input.active{
      color:#fff;
    }
  }
  .phone-input-modal{
    width:100%;
    height:100vh;
    position:fixed;
    top:r(0);
    left:50%;
    z-index: 99;
    transform: translateX(-50%);
    .bg{
      background:rgba(0,0,0,0.3);
      width:100%;
      height:100%;
    }
    .true-phone-input{
      position: absolute;
      top:r(0);
      left:r(0);
      width:100%;
      z-index: 9;
      // background:#fff;
      background: #377AFF;
      padding-bottom:r(30);
      &>.input{
        width:r(750);
        height:r(178);
        line-height: r(83);
        // border-bottom:1px solid #F2F2F5;
        padding:r(26) r(40);
        padding-top:r(95);
        &>input{
          width:r(670) !important;
          display:block;
          -webkit-appearance: none;
          background-color:#377AFF ;
          border:none;
          height:r(80) !important;
          line-height:r(50);
          // padding:r(20) r(0);
          font-size:r(37);
          color:#fff;
          border-bottom:1px solid rgba(255,255,255,0.1);
          &::-webkit-textfield-decoration-container,&::-webkit-input-placeholder{
            height:r(80) !important;
            color: #FFF;
          }
        }
      }
      .phone-history{
        height:r(505);
        overflow-y:auto;
        -webkit-overflow-scrolling: touch;
        >div{
          &>.s1{
            font-size:r(30);
            color:#000;
            float: left;
            width:100%;
          }
        }
      }
      &>.locked-phone,&>.phone-history>div{
        height:r(101);
        line-height:r(101);
        overflow: hidden;
        border-bottom:1px solid #e3e3e3;
        padding:r(0) r(40);
        &>.s1{
          font-size:r(30);
          color:#000;
          float: left;
        }
        &>.s2{
          font-size:r(24);
          color:#a5a5a5;
          float:right;
        }
        &>.s3{
          font-size:r(29);
          color:#717171;
          display:inline-block;
          vertical-align: middle;
        }
        &>img{
          width:r(30);
          vertical-align: middle;
          margin-right:r(10);
        }
      }
      &>.phone-history{
        .clear{
          text-align: center;
        }
      }
    }
  }
  .tellfee,.flowfee{
    overflow: hidden;
    padding:r(0) r(25);
    &-item{
      width:r(200);
      height:r(140);
      border:1px solid #F5F9FF;
      border-radius:r(8);
      float:left;
      margin-right:r(20);
      margin-top:r(20);
      text-align:center;
      color:#377AFF;
      padding-top:r(22);
      background:#F5F9FF;
      &-amount{
        font-size:r(34);
        line-height:r(53);
      }
      &-saleAmount{
        font-size:r(25);
        line-height:r(44);
        color: #8A9095;
      }
    }
    &-item.active{
      background:#377AFF;
      color:#fff;
      .tellfee-item-saleAmount,.flowfee-item-saleAmount{
        font-size:r(25);
        line-height:r(44);
        color: #fff;
      }
    }
    &-item:nth-child(3n){
      margin-right:0;
    }
  }
  .deduct{
    font-size:r(30);
    line-height:r(112);
    padding:r(0) r(40);
    overflow: hidden;
    &-left{
      float:left;
    }
    &-right{
      float:right;
      &>img{
        width:r(84);
        height:r(45);
        vertical-align: middle;
      }
    }
  }
  .deductNum{
    height:r(44);
    font-size:r(26);
    line-height:r(36);
    color:#fda712;
    padding:r(0) r(40);
  }
  .deductNumInput{
    width:r(670);
    height:r(66);
    background:#eff0f0;
    margin:0 auto;
    &>input{
      width:r(670);
      height:r(66);
      // line-height:r(66);
      padding:r(21) 0;
      -webkit-appearance: none;
      border:none;
      background:#eff0f0;
      text-indent:r(24);
      font-size:r(24);
    }
  }
  .shouldpay{
    height:r(160);
    line-height:r(160);
    font-size:r(34);
    padding:r(0) r(40);
    &>span{
      font-weight:bold;
      color:#FA6400;
    }
  }
  .payBtn{
    height:r(96);
    line-height:r(96);
    width:r(610);
    border-radius:r(50);
    background:#bae0ff;
    font-size:r(36);
    text-align:center;
    color:#fff;
    margin:0 auto;
  }
  .payBtn.active{
    background:#377AFF;
  }
  .payHistory{
    font-size:r(28);
    color:#666666;
    line-height:r(88);
    text-align:center;
    &>span{
      height:100%;
      display:inline-block;
    }
  }
  .ruleModal{
    width:100vw;
    height:100vh;
    overflow: hidden;
    position:fixed;
    left:0;
    top:0;
    z-index: 9;
    .bg{
      width:100vw;
      height:100vh;
      background:rgba(0,0,0,0.3);
    }
    .content{
      width:r(600);
      position:absolute;
      top:50%;
      left:50%;
      transform: translateX(-50%) translateY(-50%);
      background:#fff;
      padding:r(42) r(20);
      border-radius:r(10);
      font-size:r(28);
      color:#666;
      line-height:r(40);
      .txt{
        margin-bottom:r(40);
        width:r(560);
        height:r(746);
        padding:r(0) r(22);
        overflow-y:auto;
      }
      .tit{
        color:#000;
        font-size:r(34);
        text-align: center;
        line-height:r(50);
        font-weight: bold;
        margin-bottom:r(20);
      }
      .btn{
        width:r(520);
        height:r(80);
        background:#3982F7;
        border-radius:r(10);
        color:#fff;
        font-size:r(32);
        text-align:center;
        line-height:r(80);
        margin:0 auto;
      }
    }
  }
}
</style>